import { commerceFacetSetReducer as commerceFacetSet } from '../facet-set/facet-set-slice.js';
import { toggleExcludeDateFacetValue, toggleSelectDateFacetValue, updateDateFacetValues, } from './date-facet-actions.js';
/**
 * Loads the commerce facet set reducer and returns the available date facet action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the date facet action creators.
 *
 * @group Actions
 * @category DateFacet
 */
export function loadDateFacetActions(engine) {
    engine.addReducers({ commerceFacetSet });
    return {
        toggleSelectDateFacetValue,
        toggleExcludeDateFacetValue,
        updateDateFacetValues,
    };
}
